export default __webpack_public_path__ + "static/media/Group1018.014806de.svg";